<template>
  <div
    class="cursor-pointer px-3 py-1 hover:bg-gray-100"
    :data-test="data_test"
    :class="{ 'cursor-not-allowed! opacity-50': disabled }"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup>
import 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  data_test: { type: String, default: '' },
  disabled: { type: Boolean },
});

const onClick = () => {
  if (props.disabled) return;
  emit('click');
};
</script>
